// utils.js - Utility functions shared across modules

// Helper function to show status messages
export function showStatus(message, isError = false) {
    const statusMessage = document.getElementById('status-message');
    if (statusMessage) {
        statusMessage.textContent = message;
        statusMessage.classList.remove('hidden', 'text-green-600', 'text-red-600', 'text-gray-600');
        statusMessage.classList.add(isError ? 'text-red-600' : 'text-green-600');
        
        // Auto-hide success messages after 3 seconds
        if (!isError) {
            setTimeout(() => {
                statusMessage.classList.add('hidden');
            }, 3000);
        }
    }
}

// Helper function to format currency
export function formatCurrency(amount) {
    return new Intl.NumberFormat('fr-CM', {
        style: 'currency',
        currency: 'XAF',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(amount);
}

// Helper function to format date
export function formatDate(dateString) {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('fr-CM', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
}

// Helper function to format datetime
export function formatDateTime(dateString) {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString('fr-CM', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
}

// ─────────────────────────────────────────────────────────────────────────────
// `generateReceiptNumber()` USED TO LIVE HERE. IT IS DELETED, DELIBERATELY.
//
// It minted `TYPE-YYYYMMDD-` + `Math.floor(Math.random() * 10000)`: 10,000 slots
// drawn at random, per prefix, per day. Birthday problem — a 39% chance of a
// collision at 100 receipts/day, 11.5% at 50 (audit C1). The collision was the
// root of the worst money loss in the pre-rewrite system: Postgres raised 23505,
// the client read *any* insert error as "we must be offline", stashed the sale in
// IndexedDB, showed a GREEN « Transaction saved offline » and printed a receipt.
// Cash taken, receipt printed, sale existing nowhere.
//
// Receipt numbers now come from pre-allocated per-device sequential blocks a
// device can prove it owns (invariant 3, `db/receipt-blocks.js`), and are
// rendered by `money/receipt-format.js#formatReceiptNo`. There is deliberately no
// random-number path left in this codebase for anyone to re-adopt.
// ─────────────────────────────────────────────────────────────────────────────

// Helper function to validate email
export function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
}

// Helper function to safely get nested object properties
export function getNestedProperty(obj, path, defaultValue = null) {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj) || defaultValue;
}